var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoTrial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9897 22.5C28.0746 22.5 28.1592 22.5006 28.2434 22.5018L58.8037 22.5C65.9129 22.5 69.3062 27.1323 69.3062 31.6561C69.3062 36.1266 66.56 39.1432 63.1667 39.8968C66.9901 40.4896 70.0066 44.1523 70.0066 48.6761C70.0066 53.9002 66.5058 58.425 59.4498 58.425H33.5331L27.5 46.2524H19.2646V58.425H10V38.3972H53.4942V38.3899H56.0739C58.2474 38.3899 60.4692 36.981 60.4692 34.4211C60.4692 31.6561 58.1749 30.2021 56.0739 30.2021H53.4942V30.183H16.4084C14.8582 29.9003 13.4175 29.1523 12.2874 28.0222C10.8228 26.5586 10 24.5724 10 22.5011L27.9897 22.5ZM57.0261 51.0973C59.2348 51.0973 60.619 49.7997 60.619 47.8603C60.619 46.0295 59.288 44.0437 57.0261 44.0437H36.8908L40.4392 51.0973H57.0261Z",
    fill: "#eb672d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTrial);
export default __webpack_public_path__ + "static/media/LogoTrial.e06679cd4acf2b6ab604a3368e274f34.svg";
export { ForwardRef as ReactComponent };